module.exports = __webpack_public_path__ + "static/monetize-tile-999f08453636aeb1099e32a228c62820.png";